function enhanceSelect(select) {
  if (select.dataset.searchableEnhanced) return
  select.dataset.searchableEnhanced = "true"

  // Separate prompt options (empty value) from real options
  const allOptions = Array.from(select.options)
  const promptOpt = allOptions.find((opt) => opt.value === "")
  const options = allOptions
    .filter((opt) => opt.value !== "")
    .map((opt) => ({ value: opt.value, text: opt.text, selected: opt.selected }))

  // Wrapper for positioning the dropdown
  const wrapper = document.createElement("div")
  wrapper.style.position = "relative"
  select.insertAdjacentElement("afterend", wrapper)

  // Search input
  const input = document.createElement("input")
  input.type = "text"
  input.className = select.className.replace("form-select", "form-control")
  input.autocomplete = "off"
  input.placeholder = promptOpt ? promptOpt.text : "Type to search..."

  // Set initial display value (only for real selections, not prompts)
  const selectedOpt = options.find((o) => o.selected)
  if (selectedOpt) input.value = selectedOpt.text

  // Dropdown list
  const dropdown = document.createElement("div")
  dropdown.className = "searchable-select-dropdown"

  select.style.display = "none"
  wrapper.appendChild(input)
  wrapper.appendChild(dropdown)

  let highlightIndex = -1

  function renderOptions(filter) {
    const query = (filter || "").toLowerCase()
    const filtered = options.filter((o) => o.text.toLowerCase().includes(query))
    dropdown.innerHTML = ""
    highlightIndex = -1
    filtered.forEach((opt, i) => {
      const item = document.createElement("div")
      item.className = "searchable-select-item"
      if (opt.value === select.value) item.classList.add("active")
      item.textContent = opt.text
      item.addEventListener("mousedown", (e) => {
        e.preventDefault()
        selectOption(opt)
      })
      item.addEventListener("mouseenter", () => {
        highlightIndex = i
        updateHighlight()
      })
      dropdown.appendChild(item)
    })
  }

  function updateHighlight() {
    const items = dropdown.querySelectorAll(".searchable-select-item")
    items.forEach((item, i) => {
      item.classList.toggle("highlighted", i === highlightIndex)
    })
    if (items[highlightIndex]) {
      items[highlightIndex].scrollIntoView({ block: "nearest" })
    }
  }

  function selectOption(opt) {
    select.value = opt.value
    select.dispatchEvent(new Event("change", { bubbles: true }))
    input.value = opt.text
    closeDropdown()
  }

  function openDropdown() {
    renderOptions("")
    dropdown.style.display = "block"
  }

  function closeDropdown() {
    dropdown.style.display = "none"
    highlightIndex = -1
  }

  input.addEventListener("focus", () => {
    openDropdown()
  })

  input.addEventListener("input", () => {
    renderOptions(input.value)
    dropdown.style.display = "block"
  })

  input.addEventListener("keydown", (e) => {
    if (dropdown.style.display !== "block") return
    const items = dropdown.querySelectorAll(".searchable-select-item")
    if (!items.length) return

    if (e.key === "ArrowDown") {
      e.preventDefault()
      highlightIndex = Math.min(highlightIndex + 1, items.length - 1)
      updateHighlight()
    } else if (e.key === "ArrowUp") {
      e.preventDefault()
      highlightIndex = Math.max(highlightIndex - 1, 0)
      updateHighlight()
    } else if (e.key === "Enter") {
      e.preventDefault()
      if (highlightIndex >= 0) {
        const filtered = options.filter((o) =>
          o.text.toLowerCase().includes((input.value || "").toLowerCase())
        )
        if (filtered[highlightIndex]) selectOption(filtered[highlightIndex])
      }
    } else if (e.key === "Escape") {
      closeDropdown()
      input.blur()
    }
  })

  input.addEventListener("blur", () => {
    setTimeout(closeDropdown, 150)
  })
}

function enhanceAllSelects() {
  document.querySelectorAll("select.form-select, select.form-control").forEach(enhanceSelect)
}

enhanceAllSelects()
document.addEventListener("turbo:load", enhanceAllSelects)
document.addEventListener("turbo:morph", enhanceAllSelects)
